// extracted by mini-css-extract-plugin
export default {"post_container":"Post_post_container__4FS3R","post_image":"Post_post_image__5cssh","post_body":"Post_post_body__d3jU4","tags":"Post_tags__7kyfC"};